import React from 'react';
import styled from '@emotion/styled';
import type { CommonHeaderProps, EntryPoint } from 'corgi-types';
import type { MarginProps } from 'styled-system';
import { space } from 'styled-system';

import { useLocalization } from 'common/providers/LocaleProvider';
import BottomNavigationSection from './BottomNavigationSection';
import LanguageSwitch from './LanguageSwitch';

interface BottomSectionProps extends Pick<CommonHeaderProps, 'customer'> {
  uspEntryPoints?: EntryPoint[];
  isExpanded?: boolean;
}

const Container = styled.div<MarginProps>`
  ${space};
`;

const bottomSectionContainerStyles = {
  marginTop: 'auto',
  ml: [null, null, -32, -48],
  mr: [null, null, -32, -48],
};

// Applying this when second column in expanded, so first column gets more narrow
const MARGIN_RIGHT_SMALL = [null, null, -20, -24];

const BottomSection = ({ customer, uspEntryPoints, isExpanded }: BottomSectionProps) => {
  const { t, getLanguages } = useLocalization();

  return (
    <Container
      {...bottomSectionContainerStyles}
      {...(isExpanded ? { mr: MARGIN_RIGHT_SMALL } : {})}
    >
      <BottomNavigationSection customer={customer} uspEntryPoints={uspEntryPoints} />
      <LanguageSwitch
        languages={getLanguages().map(item => ({
          ...item,
          language: t(`h24_language_${item.language}`),
        }))}
      />
    </Container>
  );
};

export default BottomSection;
